import * as R from 'ramda';
export const isMinimum = R.pipe(R.toLower, R.endsWith('minimum'));
export const isMaximum = R.pipe(R.toLower, R.endsWith('maximum'));
export const isMinimumOrMaximum = R.either(isMinimum, isMaximum);
export const isNotNull = R.complement(R.isNil);
export const isNullOrEmpty = R.either(R.isNil, R.isEmpty);
export const isNotNullOrEmpty = R.complement(isNullOrEmpty);
export const valueIsNotNull = R.pipe(R.nthArg(1), isNotNull);
export const getKey = R.flip(R.prop);
export const getValue = values => R.curry((key, value) => R.path([key, value], values));
export const concatProps = R.join('|');
export const parseQueryString = R.pipe(
	R.replace('?', ''),
	R.split('&'),
	R.reject(R.equals('')),
	R.map(R.pipe(R.replace(/\+/g, ' '), decodeURIComponent, R.split('='))),
	R.fromPairs
);
export const parseHash = R.pipe(
	R.replace('#', ''),
	R.split('/'),
	R.reject(R.equals('')),
	R.map(R.split('=')),
	R.fromPairs
);
